import { createSlice, current } from '@reduxjs/toolkit';
import {
	getRightExerciseTypeList,
	getRightExerciseType,
	addNewRightExerciseType,
	updateRightExerciseType,
	deleteRightExerciseType,
	checkRightExerciseTypeExists,
} from './thunk';

export const initialState = {
	itemRightExerciseTypeList: [],
	itemRightExerciseType: null,
	isRightExerciseTypeLoading: false,
	isRightExerciseTypeSuccess: false,
	dataRightExerciseType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const RightExerciseTypeSlice = createSlice({
	name: 'RightExerciseType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getRightExerciseTypeList.pending, state => {
			state.isLoadingList = true;
			state.isRightExerciseTypeSuccess = false;
		});

		builder.addCase(getRightExerciseTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemRightExerciseTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isRightExerciseTypeSuccess = true;
		});

		builder.addCase(getRightExerciseTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isRightExerciseTypeSuccess = false;
		});

		builder.addCase(getRightExerciseType.pending, state => {
			state.isRightExerciseTypeLoading = true;
			state.isRightExerciseTypeSuccess = false;
		});

		builder.addCase(getRightExerciseType.fulfilled, (state, action) => {
			state.itemRightExerciseType = action.payload;
			state.isRightExerciseTypeLoading = false;
			state.isRightExerciseTypeSuccess = true;
		});

		builder.addCase(getRightExerciseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isRightExerciseTypeLoading = false;
			state.isRightExerciseTypeSuccess = false;
		});

		builder.addCase(addNewRightExerciseType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewRightExerciseType.fulfilled, (state, action) => {
			state.itemRightExerciseTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewRightExerciseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateRightExerciseType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateRightExerciseType.fulfilled, (state, action) => {
			state.itemRightExerciseTypeList = state.itemRightExerciseTypeList.map(
				rightExerciseTypeList =>
					rightExerciseTypeList._id.toString() === action.payload._id.toString()
						? { ...rightExerciseTypeList, ...action.payload }
						: rightExerciseTypeList
			);
			state.statementList = state.statementList.map(rightExerciseTypeList =>
				rightExerciseTypeList._id.toString() === action.payload._id.toString()
					? { ...rightExerciseTypeList, ...action.payload }
					: rightExerciseTypeList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateRightExerciseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteRightExerciseType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteRightExerciseType.fulfilled, (state, action) => {
			state.itemRightExerciseTypeList = current(
				state.itemRightExerciseTypeList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteRightExerciseType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkRightExerciseTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkRightExerciseTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkRightExerciseTypeExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = RightExerciseTypeSlice.actions;

export default RightExerciseTypeSlice.reducer;
